import { MutationTree } from 'vuex';
import {
    ApplicationFormWorkAccountState,
    ApplicationFormWorkAccountCurrentSaml,
    ApplicationFormWorkAccountCurrentSamlSkip,
} from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: ApplicationFormWorkAccountState): void => {
    const searchState = state.current_saml;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const currentSamlSkipState = state.current_saml_skip;
    currentSamlSkipState.error = false;
    currentSamlSkipState.errorCode = undefined;
    currentSamlSkipState.errorMsg = undefined;
};

export const mutations: MutationTree<ApplicationFormWorkAccountState> = {
    // 一覧系
    [types.CURRENT_SAML_START](state) {
        resetErrors(state);
        const searchState = state.current_saml;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.CURRENT_SAML_SUCCESS](
        state,
        payload: { count: number; work_accounts: Array<ApplicationFormWorkAccountCurrentSaml> }
    ) {
        state.currentSamlCount = payload.count;
        state.currentSamls = payload.work_accounts;

        const searchState = state.current_saml;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.CURRENT_SAML_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.current_saml;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 一覧省略系
    [types.CURRENT_SAML_SKIP_START](state) {
        resetErrors(state);
        const currentSamlSkipState = state.current_saml_skip;
        currentSamlSkipState.isProcessing = true;
        currentSamlSkipState.isFetchSuccess = false;
    },

    [types.CURRENT_SAML_SKIP_SUCCESS](state, payload: { work_account: ApplicationFormWorkAccountCurrentSamlSkip }) {
        state.currentSamlSkip = payload.work_account;

        const currentSamlSkipState = state.current_saml_skip;
        currentSamlSkipState.isProcessing = false;
        currentSamlSkipState.isFetchSuccess = true;
    },

    [types.CURRENT_SAML_SKIP_FAILURE](state, payload: { code: string; message: string }) {
        const currentSamlSkipState = state.current_saml_skip;
        currentSamlSkipState.errorCode = payload.code;
        currentSamlSkipState.errorMsg = payload.message;
        currentSamlSkipState.error = true;
        currentSamlSkipState.isProcessing = false;
        currentSamlSkipState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.current_saml;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const currentSamlSkipState = state.current_saml_skip;
        currentSamlSkipState.isProcessing = false;
        currentSamlSkipState.isFetchSuccess = false;
    },
};
